import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";

export const deleteUser = async (email: string, realms: string[]) => {
    for (const realm of realms) {
        const url = `${NGROK}/api/keycloak/${realm}/users`
        await apiClient({
            method: "PUT",
            url: url,
            data: [email]
        });
    }
};

export const editRegisterUser = async (payload: any, roleType: string, email: string, computerList: any[], tenantName: string, selectedTagIds: any) => {
    const url = `${NGROK}/api/${tenantName}/updateRoles?roleType=${roleType}&email=${email}&computerList=${computerList}&tags=${selectedTagIds.join(",")}`
    await apiClient({
        method: "PUT",
        url: url,
        data: payload,
    });
}